import { Block, Text, Inline } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
import SlateCommandsTypes from '../../../types/SlateCommandsTypes';
export default function onCommand(command, editor, next) {
  if (editor.query('isApplyingRemoteChange')) {
    return next();
  }

  if (command.type === 'toggleMark') {
    editor.toggleMarkOnTableSelection(command.args[0], next);
  } else if (command.type === 'splitBlock' && editor.isSelectionInTable()) {
    if (editor.isSelectionInLastTableCell()) {
      editor.insertBlock(BlockTypes.UNSTYLED);
    }

    return false;
  } else if (command.type === 'setBlocks' && editor.isSelectionInTable()) {
    return false;
  } else if (command.type === 'insertFragment' && editor.isSelectionInTable()) {
    editor.withoutNormalizing(function () {
      editor.emptyTableCellsAtSelection();
      var block = command.args[0]; // Fragment could be a block containing other block, or a block containing
      // leaves

      var nodes = Block.isBlockList(block.nodes) ? block.getBlocks().flatMap(function (child) {
        return child.nodes;
      }) : block.nodes;
      nodes.forEach(function (node) {
        if (Inline.isInline(node)) {
          editor.insertInline(node).moveForward();
        } else if (Text.isText(node)) {
          editor.insertText(node.text, node.marks);
        }
      });
    });
    return false;
  } // Keydown events outside of the editor are forwarded to it when a table is
  // selected. To avoid unexpected commands, with ignore all user intended ones.


  if (editor.value.selection.isUnset && SlateCommandsTypes.WithIntent.includes(command.type)) {
    return false;
  }

  return next();
}